var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDotMatrix = function SvgDotMatrix(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-16 -269)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(16 269)",
    fill: "#f6c02b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4-2",
    "data-name": "Ellipse 4",
    cx: 2,
    cy: 2.5,
    rx: 2,
    ry: 2.5,
    transform: "translate(30 269)",
    fill: "#f6c02b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4-3",
    "data-name": "Ellipse 4",
    cx: 2,
    cy: 2.5,
    rx: 2,
    ry: 2.5,
    transform: "translate(44 269)",
    fill: "#f6c02b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4-4",
    "data-name": "Ellipse 4",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(57 269)",
    fill: "#f6c02b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4-5",
    "data-name": "Ellipse 4",
    cx: 2.5,
    cy: 2,
    rx: 2.5,
    ry: 2,
    transform: "translate(16 283)",
    fill: "#f6c02b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4-6",
    "data-name": "Ellipse 4",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(30 283)",
    fill: "#f6c02b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4-7",
    "data-name": "Ellipse 4",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(44 283)",
    fill: "#f6c02b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4-8",
    "data-name": "Ellipse 4",
    cx: 2.5,
    cy: 2,
    rx: 2.5,
    ry: 2,
    transform: "translate(57 283)",
    fill: "#f6c02b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4-9",
    "data-name": "Ellipse 4",
    cx: 2.5,
    cy: 2,
    rx: 2.5,
    ry: 2,
    transform: "translate(16 297)",
    fill: "#f6c02b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(16 310)",
    fill: "#f6c02b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4-10",
    "data-name": "Ellipse 4",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(30 297)",
    fill: "#f6c02b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 2,
    cy: 2.5,
    rx: 2,
    ry: 2.5,
    transform: "translate(30 310)",
    fill: "#f6c02b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4-11",
    "data-name": "Ellipse 4",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(44 297)",
    fill: "#f6c02b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4-12",
    "data-name": "Ellipse 4",
    cx: 2.5,
    cy: 2,
    rx: 2.5,
    ry: 2,
    transform: "translate(57 297)",
    fill: "#f6c02b"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDotMatrix, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dot_matrix.5719910f.svg";
export { ForwardRef as ReactComponent };